









































/**
 * @copyright       Palace Resorts
 * @description     Componente de registro de nuevo contrato
 * @author          Leticia Beltran
 * @creationDate    17/08/2021
 */

import GlobalMixin from "@/mixins/global";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
import SecctionDocuments from "@/models/store/SecctionDocuments";
import moment from "moment";
import i18nMessages from "./i18n/messages";
import Datatable from "@/components/DatatableContract/DatatableRegisterContract.vue";

export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    Datatable,
  },
  props: ["id"],
  data: () => {
    return {
      moduleName: "DATATABLE_REGISTER_CONTRACT",
      tab: null,
      // DOCUMENTOS POR SECCION
      documentosSeccion: {
        documentoTipoID: "",
      },
      doctoSeccion: 4,
      //Documento
      headersDocuments: [],
      dataTableDocument: [],
      loadingDocumentos: true,
      totalrdocumentos: 0,
      // PROVEEDOR
      nombreProveedor: "",
      documentoTipoID: "",
      proveedor: {
        userID: "",
        userName: "",
        userProveedorSubcontratacionObra: false,
      },
    };
  },
  methods: {
    init() {
      this.getID();
      this.getDocumentsTypes();
      this.headersDocuments = [
        {
          text: "ID",
          align: "start",
          value: "docID",
        },
        {
          text: "Sociedad",
          //align: "start",
          value: "docEmpresaClave",
        },
        {
          text: "Pedido",
          value: "docOCNumero",
        },
        {
          text: "Archivo",
          value: "docBucketKeyFile",
          file: true,
        },
        {
          text: "Estatus",
          value: "docEstatusID",
          template: this.getStatus,
          color: this.getColor,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ];
    },
    // PROVEEDOR
    getID() {
      dataService.getByID(this.id).then((Response: ResponseData) => {
        this.proveedor = Response.data.data[0];
        this.nombreProveedor =
          (this.proveedor.userID ?? "") +
          " - " +
          (this.proveedor.userName ?? "");
        return "";
      });
    },

    // DOCUMENTOS POR SECCION
    getDocumentsTypes() {
      dataService
        .getSectionDocuments1(this.doctoSeccion)
        .then((Response: ResponseData) => {
          this.documentosSeccion = Response.data.data[0];
          this.documentoTipoID = this.documentosSeccion.documentoTipoID;
          this.getTableDocumentProvider(this.documentoTipoID);
        })
        .catch((e: Error) => {});
    },

    getTableDocumentProvider(tipoID: any) {
      dataService
        .getDocumentProvider(this.id, tipoID)
        .then((Response: ResponseData) => {
          this.dataTableDocument = Response.data.data;
        })
        .catch((e: Error) => {})
        .finally(() => {
          this.loadingDocumentos = false;
        });
    },

    // METODOS GENERICOS
    dateFormatted(value: string) {
      return moment
        .utc(value)
        .locale("es-mx")
        .format("L");
    },

    getStatus(value: number) {
      switch (value) {
        case 0:
          return "Inactivo";
          break;
        case 1:
          return "Activo - Pendiente por autorizar";
          break;
        case 2:
          return "Autorizado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado por el SAT";
          break;
        default:
          return "Inactivo";
          break;
      }
    },
    getColor(value: number) {
      switch (value) {
        case 0:
          return "blue-grey";
          break;
        case 1:
          return "orange";
          break;
        case 2:
          return "green";
          break;
        case 3:
          return "red";
          break;
        case 4:
          return "red";
          break;
        default:
          return "blue-grey";
          break;
      }
    },
  },
  mounted() {
    this.init();
  },
});
